var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 129",
    d: "M80.0001 40C80.0001 62.0914 62.0915 80 40.0001 80C17.9087 80 7.27271e-05 62.0914 7.27271e-05 40C7.27271e-05 17.9086 17.9087 0 40.0001 0C62.0915 0 80.0001 17.9086 80.0001 40Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.2484 52C38.2027 52 38.1519 52 38.1113 51.9949C37.3852 51.954 36.72 51.6065 36.2681 51.0392L27.5562 40.5C26.6828 39.3961 26.8554 37.7913 27.9522 36.9071C29.0541 36.028 30.6486 36.212 31.522 37.3057L38.4566 45.6166L54.2234 29.7475C55.2136 28.7508 56.8233 28.7508 57.8135 29.7475C58.8037 30.7441 58.8037 32.3642 57.8135 33.3608L40.0409 51.2487C39.5687 51.7342 38.9187 52 38.2484 52Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0ae5e9b7.svg";
export { ForwardRef as ReactComponent };